import { Box, Flex, Text } from "@storyofams/react-ui";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { RichText } from "~components/common/RichText";
import { NhAccordion } from "~components/common/Story/NhComponents/NhAccordion";
import { ProductChoiceAccordion } from "~components/product/components/ProductChoiceAccordion";
import useMediaQuery from "~hooks/useMediaQuery";

export const InfoAccordion = ({ content }) => {
  const bundlesIndex = content
    .filter(({ content }) => content)
    .findIndex(({ component }) => component === "bundle");
  const [isOpen, setIsOpen] = useState(
    bundlesIndex === -1 ? null : bundlesIndex
  );
  const close = () => setIsOpen(null);
  const scrollToTop = (i) => {
    const el = document?.getElementById(`${"top" + i}`);

    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  };
  const matchesMobile: boolean = useMediaQuery("(max-width: 769px)");
  return (
    <Box mb={"29px"}>
      {content
        .filter(({ content }) => content)
        .map((item, i) => {
          switch (item.component) {
            case "bundle":
              return (
                <Box
                  key={i}
                  id={"top" + i}
                  css={{
                    "scroll-margin-top": matchesMobile ? "50px" : "130px",
                  }}
                  onClick={() => {
                    if (isOpen === i) setIsOpen(false);
                    else {
                      setIsOpen(i);
                      scrollToTop(i);
                    }
                  }}
                >
                  <NhAccordion
                    close={isOpen !== i}
                    isOpen
                    isFirst
                    key={i}
                    title={`Deze bundel bestaat uit:`}
                  >
                    <Bundle content={{ ...item }} />
                  </NhAccordion>
                </Box>
              );
            case "accordion_text":
              return (
                <Box
                  key={i}
                  id={"top" + i}
                  css={{
                    "scroll-margin-top": matchesMobile ? "50px" : "130px",
                  }}
                  onClick={() => {
                    if (isOpen === i) setIsOpen(false);
                    else {
                      setIsOpen(i);
                      scrollToTop(i);
                    }
                  }}
                >
                  <NhAccordion
                    key={i}
                    isFirst
                    title={item.title}
                    close={isOpen !== i}
                  >
                    <RichText
                      fontSize={2}
                      lineHeight={"22.4px"}
                      color="#1D1D1BCC"
                      text={item.content}
                    />
                  </NhAccordion>
                </Box>
              );
            case "accordion_ingredients":
              return (
                <Box
                  id={"top" + i}
                  css={{
                    "scroll-margin-top": matchesMobile ? "50px" : "130px",
                  }}
                  key={i}
                  onClick={() => {
                    if (isOpen === i) setIsOpen(false);
                    else {
                      setIsOpen(i);
                      scrollToTop(i);
                    }
                  }}
                >
                  <NhAccordion close={isOpen !== i} key={i} title={item.title}>
                    <Ingredients content={item.content} close={close} />
                  </NhAccordion>
                </Box>
              );
            case "product_choice":
              return (
                <Box
                  key={i}
                  id={"top" + i}
                  css={{
                    "scroll-margin-top": matchesMobile ? "50px" : "130px",
                  }}
                  onClick={() => {
                    if (isOpen === i) setIsOpen(false);
                    else {
                      setIsOpen(i);
                      scrollToTop(i);
                    }
                  }}
                >
                  <NhAccordion
                    close={isOpen !== i}
                    key={i}
                    title={"Personaliseer of maak het zelf"}
                  >
                    <ProductChoiceAccordion
                      content={{ ...item, products: item.content }}
                    />
                  </NhAccordion>
                </Box>
              );
            default:
              return null;
          }
        })}
    </Box>
  );
};

const Ingredients = ({ content, close }) => {
  const scrollToIngredientsSection = () => {
    const el = document?.getElementById("ingredients-cards");

    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Box onClick={(e) => e.stopPropagation()}>
      {content?.map((item, i) => (
        <Flex mt={i && 2} key={item.title}>
          <Box
            mr={2}
            position={"relative"}
            width={86}
            height={61}
            maxWidth={86}
            flexGrow={0}
            flexShrink={0}
          >
            <Image
              objectFit="cover"
              layout="fill"
              src={item.image.filename}
            ></Image>
          </Box>
          <Box>
            <Text fontWeight={500} fontSize={2} lineHeight={"22.4px"}>
              {item.title}
            </Text>
            <Text
              mt="6px"
              color={"#1D1D1BCC"}
              fontSize={"14px"}
              lineHeight={"19.6px"}
            >
              {item.description}
            </Text>
          </Box>
        </Flex>
      ))}
      <Text
        mt={2}
        fontWeight={500}
        fontSize={2}
        color="#1D1D1BCC"
        textAlign={"end"}
        cursor={"pointer"}
        onClick={() => {
          close();
          setTimeout(() => scrollToIngredientsSection(), 500);
        }}
      >
        View all ingredients
      </Text>
    </Box>
  );
};
const Bundle = ({ content }) => {
  return (
    <Box onClick={(e) => e.stopPropagation()}>
      {content.content.map(({ productVariant }, i) => (
        <Link
          key={productVariant.id}
          href={`/products/${productVariant.product.handle}`}
        >
          <Flex
            width={"100%"}
            mt={i && 1}
            cursor={"pointer"}
            alignItems={"center"}
          >
            <Box
              border={"1px solid #E2DFDF"}
              borderRadius={"6px"}
              overflow={"hidden"}
              width={[58, 53]}
              height={[58, 53]}
              flexShrink={1}
              position={"relative"}
              mr={"10px"}
            >
              <Image
                layout="fill"
                objectFit="cover"
                src={productVariant.image.url}
              ></Image>
            </Box>
            <Box>
              <Text
                fontWeight={500}
                lineHeight={["19.6px", "22.4px"]}
                fontSize={["14px", 2]}
              >
                {`1 × ${productVariant.product.title}`}
              </Text>
              <Text
                color={"#767473"}
                fontWeight={400}
                lineHeight={["16.8px", "19.6px"]}
                fontSize={["12px", "14px"]}
              >
                {productVariant.title}
              </Text>
            </Box>
          </Flex>
        </Link>
      ))}
    </Box>
  );
};
